'use client';

import { clsx } from 'clsx';
import { FC } from 'react';

import { IconCaretLeft } from 'src/general/Icons/IconCaretLeft';
import { IconCaretRight } from 'src/general/Icons/IconCaretRight';
import { Button } from 'src/general/components/Button/Button';

import { ButtonIcon } from '../Button/ButtonIcon';

interface Props {
  page: number;
  type: 'page' | 'next' | 'previous' | 'start-ellipsis' | 'end-ellipsis';
  selected: boolean;
  href?: string;
  rel?: string;
}

export const PaginationButton: FC<Props> = ({ page, type, selected, href, rel }) => {
  if (type === 'start-ellipsis' || type === 'end-ellipsis') {
    return <div className="Pagination-ellipsis">&hellip;</div>;
  }
  if (type === 'page') {
    return (
      <Button
        href={href}
        rel={rel}
        disabled={!href}
        className={clsx('Pagination-button', { 'Pagination-currentPage': selected })}
        data-testid={`Pagination-component-button-${page}`}
        variant="tertiary"
        size="small"
      >
        {page}
      </Button>
    );
  }
  if (type === 'previous') {
    return (
      <>
        <ButtonIcon
          href={href}
          rel={rel}
          disabled={!href}
          className={clsx('Pagination-button', 'Pagination-buttonPrevNext', 'Pagination-buttonPrevNext-icon')}
          data-testid="Pagination-component-button-prev"
          variant="tertiary"
          size="small"
          title="Previous page"
          Icon={IconCaretLeft}
        />
        <Button
          href={href}
          rel={rel}
          disabled={!href}
          className={clsx('Pagination-button', 'Pagination-buttonPrevNext', 'Pagination-buttonPrevNext-text')}
          data-testid="Pagination-component-button-prev"
          variant="tertiary"
          size="small"
          startIcon={<IconCaretLeft />}
          title="Previous page"
        >
          Prev
        </Button>
      </>
    );
  }
  if (type === 'next') {
    return (
      <>
        <ButtonIcon
          href={href}
          rel={rel}
          disabled={!href}
          className={clsx('Pagination-button', 'Pagination-buttonPrevNext', 'Pagination-buttonPrevNext-icon')}
          data-testid="Pagination-component-button-next"
          variant="tertiary"
          size="small"
          title="Next page"
          Icon={IconCaretRight}
        />
        <Button
          href={href}
          rel={rel}
          disabled={!href}
          className={clsx('Pagination-button', 'Pagination-buttonPrevNext', 'Pagination-buttonPrevNext-text')}
          data-testid="Pagination-component-button-next"
          variant="tertiary"
          size="small"
          endIcon={<IconCaretRight />}
          title="Next page"
        >
          Next
        </Button>
      </>
    );
  }
  return null;
};
